import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { scrollToTop } from 'utils/Link';

import SubMenu from './SubMenu';

const MenuItem = ({text, link, locale, item, active, ...props}) => {
  return (
    <span className={`menu-item ${active && "active"}`}>
      { link ? <Link onClick={scrollToTop} to={`/${locale}${link}`}>{text}</Link>: text }
      { props.list.length > 0 && <SubMenu item={item} locale={locale} {...props} /> }
    </span>
  );
};

export default MenuItem;

MenuItem.propTypes = {
  list: PropTypes.array,
};

MenuItem.defaultProps = {
  list: []
};



// WEBPACK FOOTER //
// ./src/components/Header/MenuItem.js